import React, { useState } from "react"
import { Box, Button, Divider, Tab, Tabs } from "@material-ui/core"
import moment from "moment"
import { NoItemsMessage, SearchInput, LoadingSpinner, Icon, RequirePermissions } from "../../components"
import { toId } from "../../utils"
import { useQueryTriggers } from "../../data/triggers/useQueryTriggers"
import { useMutationDeleteTrigger } from "../../data/triggers/useMutationTrigger"
import TriggerCreator from "../../components/Triggers/TriggerCreator"
import TriggerActionCard from "../../components/Triggers/TriggerActionCard"
import SettingsFooter from "../../components/Settings/SettingsFooter"

const Triggers = () => {
  const { data, refetch, loading } = useQueryTriggers()
  const [type, setType] = useState("ScheduleTrigger")
  const [deleteTrigger] = useMutationDeleteTrigger()

  const [open, setOpen] = useState(false)
  const [edit, setEdit] = useState(null)
  const [searchText, setSearchText] = useState("")

  const handleFilter = (text) => {
    setSearchText(text.toLowerCase())
  }

  const handleCreate = () => {
    setOpen(true)
  }
  const handleCreateClose = () => {
    setOpen(false)
    setEdit(null)
    refetch()
  }
  const handleEdit = (editTrigger) => {
    setEdit(editTrigger)
    setOpen(true)
  }
  const handleDelete = async (item) => {
    await deleteTrigger({ variables: { id: toId(item) } })
    refetch()
  }

  const hasFilter = false // data?.triggers.length > 1

  const triggers =
    data?.triggers
      .filter((item) => item.__typename === type && (!searchText || item.name.toLowerCase().includes(searchText)))
      .sort((a, b) => (moment(a.createdAt).isAfter(moment(b.createdAt)) ? -1 : 1)) || []

  return (
    <>
      {open && <TriggerCreator open={open} onClose={handleCreateClose} edit={edit} />}

      <Tabs
        variant="standard"
        value={type}
        indicatorColor="primary"
        textColor="primary"
        aria-label="Select trigger type"
      >
        <Tab label="Scheduled" value="ScheduleTrigger" onClick={() => setType("ScheduleTrigger")} />
        <Tab label="Events" value="EventTrigger" onClick={() => setType("EventTrigger")} />
      </Tabs>
      <Divider />

      {hasFilter && <SearchInput placeholder="Filter" boxProps={{ pl: 0, pr: 0 }} onChange={handleFilter} />}

      <Box pt={5} mb={5} data-cy="Triggers-list">
        {triggers.map((trigger) => (
          <TriggerActionCard key={toId(trigger)} trigger={trigger} onEdit={handleEdit} onDelete={handleDelete} />
        ))}

        {!data && loading && (
          <Box display="flex" justifyContent="center">
            <LoadingSpinner size={60} />
          </Box>
        )}

        {triggers.length === 0 && (
          <NoItemsMessage>No {type === "ScheduleTrigger" ? <>schedule</> : <>event</>} triggers created</NoItemsMessage>
        )}
      </Box>

      <RequirePermissions requires="trigger_create">
        <SettingsFooter>
          <Button variant="contained" color="primary" onClick={handleCreate} data-cy="Button-create-trigger">
            <Icon name="trigger" /> <Box ml={1}>Create trigger</Box>
          </Button>
        </SettingsFooter>
      </RequirePermissions>
    </>
  )
}

export default Triggers
